'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.default = secure3dDepositAPI;

var _PaymentsApi = require('../PaymentsApi');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** perform3dsDepositAPI v1
 * @returns {void}
 * **/
function secure3dDepositAPI() {
  /** get3DDetails
   * @param {TdsDetailsType} cardId Card identification number
   * @param {TdsDetailsType} depositResult Card identification number
   * @param {TdsDetailsType} tdsTermUrl Card identification number
   * @returns {void}
   * **/
  function get3DDetails(cardId, depositResult, tdsTermUrl) {
    return new _promise2.default(function (resolve, reject) {
      var pmtApi = new _PaymentsApi.PaymentsApi();

      pmtApi.get3DSDetails(cardId, depositResult, tdsTermUrl).then(function (data) {
        resolve(data);
      }).catch(function (e) {
        reject(e);
      });
    });
  }

  /** completePayment
   * @param {Object} activeDepositData active deposit data
   * @param {Object} data Response from challenge iframe
   * @returns {void}
   * **/
  function complete3DSPayment(activeDepositData, data) {
    return new _promise2.default(function (resolve, reject) {
      var pmtApi = new _PaymentsApi.PaymentsApi();

      pmtApi.complete3DSPayment(activeDepositData.cardId, activeDepositData.amount, data.PaRes, data.MD).then(function (response) {
        resolve(response);
      }).catch(function (e) {
        reject(e);
      });
    });
  }

  return {
    get3DDetails: get3DDetails,
    complete3DSPayment: complete3DSPayment
  };
}